import Job from '@/models/Job'
import Api from '@/api'
import { each, find, findIndex } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [], // my jobs, saved jobs, most recent
    listMeta: {},
    popularJobsList: [],
    popularJobsListMeta: {},
    jobDetails: null
  },

  mutations: {
    setJobList(state, jobs) {
      each(jobs, job => {
        const exist = find(state.list, { id: job.id })
        if (!exist) {
          state.list.push(new Job(job))
        }
      })
    },

    setJobListMeta(state, meta) {
      state.listMeta = meta
    },

    clearJobList(state) {
      state.list = []
      state.listMeta = {}
    },

    setPopularJobList(state, jobs) {
      each(jobs, job => {
        const exist = find(state.popularJobsList, { id: job.id })
        if (!exist) {
          state.popularJobsList.push(new Job(job))
        }
      })
    },

    setPopularJobListMeta(state, meta) {
      state.popularJobsListMeta = meta
    },

    clearPopularJobList(state) {
      state.popularJobsList = []
      state.popularJobsListMeta = {}
    },

    setJobDetails(state, job) {
      if (job instanceof Job) {
        state.jobDetails = job
      } else {
        state.jobDetails = new Job(job)
      }
    },

    clearJobDetails(state) {
      state.jobDetails = null
    },

    setJobListItemDetails(state, job) {
      const index = findIndex(state.list, { id: job.id })
      state.list[index].title = job.title
      state.list[index].location = job.location
      state.list[index].created_at = job.created_at
    },

    clearJobListItemDetails(state, id) {
      const index = findIndex(state.list, { id: id })
      state.list.splice(index, 1)
    }
  },

  actions: {
    async getJobs({ commit }, params) {
      let query = Job.page(params.page || 1)
        .limit(params.limit)
        .include(['photos'])

      if (params.only_popular) {
        query.where('only_popular', params.only_popular)
      } else if (params.only_favorited) {
        query.where('only_favorited', params.only_favorited)
      } else if (params.author_id) {
        query.where('author_id', params.author_id)
      }

      if (params.filters) {
        if (params.filters.category_id) {
          query.where('category_id', params.filters.category_id)
        }
        if (params.filters.search) {
          query.where('search', params.filters.search)
        }
        if (params.filters.suburb) {
          query.where('suburb', params.filters.suburb)
        }
        if (params.filters.within_distance_to) {
          query.where('within_distance_to', params.filters.within_distance_to)
        }
      }

      const res = await query.get(params)

      if (params.only_popular) {
        // popular jobs
        commit('setPopularJobList', res.data)
        commit('setPopularJobListMeta', res.meta)
      } else {
        // my jobs, saved jobs, most recent
        commit('setJobList', res.data)
        commit('setJobListMeta', res.meta)
      }
    },

    async getJobDetails({ commit }, id) {
      const { data } = await Api.get(`jobs/${id}`)
      commit('setJobDetails', data.data)
    },

    async createJob({ commit, state }, formData) {
      const { data } = await Api.post(`jobs`, formData)
      state.list.unshift(data.data)
    },

    async updateJob({ commit, state }, formData) {
      await Api.put(`jobs/${formData.id}`, formData)
    },

    async deleteJob({ commit, state }, id) {
      await Api.delete(`jobs/${id}`)
      commit('clearJobListItemDetails', id)
    },

    async saveJob({ commit }, id) {
      await Api.post(`jobs/${id}/favorite`, id)
    },

    async unsaveJob({ commit }, id) {
      await Api.post(`jobs/${id}/unfavorite`, id)
    }
  }
}
